export default {
	computed: {
		primaryUniversity() {
			return this.$auth.user?.universities.find(
				(u) => u.account.is_primary,
			);
		},

		userHasPrimaryUniversity() {
			return !!this.primaryUniversity;
		},

		userHasVerifiedUniversities() {
			return Boolean(this.verifiedUniversities.length);
		},

		userSubdomain() {
			const partneredUniversities =
				this.$store.getters['partners/getPartners'];
			const availableSubdomains = partneredUniversities.map(
				(p) => p.code,
			);

			if (!this.userHasPrimaryUniversity) {
				return '';
			}

			return availableSubdomains.includes(this.primaryUniversity.code)
				? this.primaryUniversity.code
				: '';
		},

		verifiedUniversities() {
			return (
				this.$auth.user.universities?.filter((v) =>
					Boolean(v.account.verified_at),
				) || []
			);
		},
	},

	async beforeMount() {
		await this.$store.dispatch('cv-profile/fetchCvReview');

		await this.$store.dispatch('partners/getPartners');

		if (!this.userHasVerifiedUniversities) {
			return (
				this.$route.path !== '/account/verify-university' &&
				this.$router.replace(
					this.localePath({ name: 'account-verify-university' }),
				)
			);
		}

		if (this.$route.path === '/account/verify-university') {
			return this.$router.replace(this.localePath({ name: 'jobs' }));
		}

		const appUrl = process.env.APP_URL;
		const { protocol, hostname, pathname } = location;
		const domain = hostname
			.split('.')
			.reverse()
			.slice(0, 3)
			.reverse()
			.join('.');
		const subdomain = hostname.split('.').reverse().slice(3).join('.');

		if (subdomain === this.userSubdomain) return;

		const from = new URL(
			this.$router.resolve(this.$route).href,
			location.origin,
		).href;

		const to =
			this.userSubdomain &&
			hostname.split('.').length === appUrl.split('.').length
				? `${protocol}//${this.userSubdomain}.${domain}${pathname}`
				: `${appUrl}${pathname}`;

		if (from === to) return;

		location.replace(to);
	},
};
